module.exports = "<div class=\"container-fluid home-header\"> <div class=row> <div class=col-sm-12> <div class=row> <div class=col-sm-2> <div class=logo ui-sref=home.main style=cursor:pointer> <img src=" + require("../../assets/img/logo-white.png") + " /> </div> </div> <div class=\"col-sm-2 col-sm-offset-8\"> <div class=logout> <a ng-click=$ctrl.logout()>Logout</a> </div> </div> </div> </div> </div> </div> <div class=container> <div class=wrapper> <toast></toast> <ui-view></ui-view> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 402
// module chunks = 0